export class ModalButton {
    constructor (def) {
        this.show = false
        this.name = def.name || ''
        this.text = def.text || ''
        this.action = def.action
        this.disabled = def.disabled
        this.defaultButton = def.defaultButton === true
    }
}

export class ModalConfig {
    constructor (def) {
        this.show = false
        this.buttons = []

        if (def.accept) {
            this.buttons.push(new ModalButton({
                name: 'accept',
                text: def.accept,
                action: def.acceptAction || 'accept',
                disabled: def.disabled,
                defaultButton: true
            }))
        }

        if (def.reject) {
            this.buttons.push(new ModalButton({
                name: 'reject',
                text: def.reject,
                action: def.rejectAction || 'reject'
            }))
        }

        this.autoClose = def.autoClose === true

        this.header = def.hasOwnProperty('header') ? def.header : false
        this.content = def.hasOwnProperty('content') ? def.content : false
    }

    addButton (button) {
        this.buttons.push(button)
    }

    open () {
        this.show = true
    }

    close () {
        this.show = false
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/modal.js